import React from "react";
import Loader from "../../components/Loader";

/**
 * 在分类介绍下方横向展示商品属性筛选项。
 * @param {Object} props 组件属性
 * @param {Object} props.parentAttributes 属性和值聚合数据
 * @param {boolean} props.isLoadingValues 是否正在加载属性值
 * @param {Function} props.setOptions 更新当前筛选条件
 * @param {Object} props.selectedOptions 当前已选择的筛选条件
 * @returns {JSX.Element|null} 横向属性筛选区域
 */
const InlineAttributesFilter = ({
  parentAttributes,
  isLoadingValues,
  setOptions,
  selectedOptions = {},
}) => {
  const attributesValues = parentAttributes?.attributesValues || {};
  const attributeNames = Object.keys(attributesValues);

  /**
   * 根据用户选择更新属性筛选条件。
   * @param {React.ChangeEvent<HTMLSelectElement>} event 下拉框变更事件
   * @returns {void}
   */
  const handleAttributeChange = (event) => {
    const { name, value } = event.target;

    setOptions((prev) => {
      const options = { ...prev };

      if (!value) {
        delete options[name];
        return options;
      }

      options[name] = value;
      return options;
    });
  };

  /**
   * 清空所有属性筛选条件。
   * @returns {void}
   */
  const handleClearFilters = () => {
    setOptions({});
  };

  if (isLoadingValues) return <Loader />;
  if (attributeNames.length <= 0) return null;

  return (
    <section className="w-full mb-6 border border-gray-200 bg-white">
      <div className="flex items-center justify-between gap-4 border-b border-gray-200 px-4 py-3">
        <h2 className="text-sm font-bold text-gray-900">Filters</h2>
        <button
          type="button"
          onClick={handleClearFilters}
          className="text-sm font-semibold text-[#2684fe] hover:text-[#0f5ec9]"
        >
          Clear Filters
        </button>
      </div>
      <div className="w-full overflow-x-auto">
        <div className="flex min-w-max gap-3 px-4 py-4">
          {attributeNames.map((attributeName) => (
            <label
              key={attributeName}
              className="flex min-w-[190px] max-w-[260px] flex-col gap-2 border-r border-gray-200 pr-3 last:border-r-0"
            >
              <span className="line-clamp-2 min-h-[40px] text-xs font-bold text-gray-900">
                {attributeName}
              </span>
              <select
                name={attributeName}
                value={selectedOptions[attributeName] || ""}
                onChange={handleAttributeChange}
                className="w-full border border-gray-300 bg-white px-2 py-2 text-sm text-gray-800 focus:border-[#2684fe] focus:outline-none"
              >
                <option value="">All</option>
                {attributesValues[attributeName]?.map((item, index) => (
                  <option key={`${attributeName}-${item}-${index}`} value={item}>
                    {item}
                  </option>
                ))}
              </select>
            </label>
          ))}
        </div>
      </div>
    </section>
  );
};

export default InlineAttributesFilter;
